import React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";

import AddQuestionForm from "layouts/library/question-list/components/AddQuestionForm";

const AddQuestionPopup = ({ open, close }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      sx={{
        "& .MuiPaper-root": {
          width: 350,
          height: 350,
          overflowX: "hidden",
        },
      }}
      onClose={() => {
        close(false);
      }}
    >
      <Box
        role="presentation"
        // onClick={() => { close(false) }}
      >
        <AddQuestionForm showAsPopup={close} />
      </Box>
    </Drawer>
  );
};

export default AddQuestionPopup;
